import { Badge } from '@uhg-abyss/web/ui/Badge';

type Props = {
  message: string;
};

export const TerminationStatusIndicator = ({ message = '' }: Props) => (
  <div data-testid="termination-date-container">
    <Badge icon={'warning'} variant="warning">
      {message}
    </Badge>
  </div>
);
